import { IAtTextProps } from './at-text';

export const atTextMockData: IAtTextProps = {
  children: 'Schumacher homes',
  className: 'text-bold underline italic',
  type: 'label',
};
